<rt-dialog-header [heading]="'tlc.positions.rename_position_dialog.header' | translate" />

<rt-dialog-body variant="white">
  <div class="form">
    <span class="title">{{ 'tlc.positions.rename_position_dialog.form.title' | translate }}</span>
    <span>{{ 'tlc.positions.rename_position_dialog.form.subtitle' | translate }}</span>
    <rt-form-field>
      <rt-input
        [formControl]="nameControl"
        [rtFormError]="nameFieldErrors"
        [autoFocus]="true"
        (keydown.enter)="save()"
      />
    </rt-form-field>
  </div>
</rt-dialog-body>
<rt-dialog-footer>
  <rt-button variant="plain" (click)="cancel()">
    {{ 'tlc.common.cancel' | translate }}
  </rt-button>
  <rt-button
    variant="primary"
    (click)="save()"
    [disabled]="nameControl.invalid"
    [loading]="loading()"
  >
    {{ 'tlc.common.save' | translate }}
  </rt-button>
</rt-dialog-footer>
